import React from 'react'

interface FieldProps {
  label: React.ReactNode
  htmlFor?: string
  children: React.ReactNode
  className?: string
  labelClassName?: string
}

// A generic labelled form field: a label above its control with consistent spacing. Shared across the
// platform's configuration forms (column config, menus, panels, …). The label is set as the settings
// dialogs set theirs: 13px medium, 6px above its control, on the panels' 12px gutter.
const Field: React.FC<FieldProps> = ({
  label,
  htmlFor,
  children,
  className = 'flex flex-col gap-1.5 px-3 pt-3',
  labelClassName = 'text-[13px] font-medium text-body'
}) => (
  <div className={className}>
    <label htmlFor={htmlFor} className={labelClassName}>
      {label}
    </label>
    {children}
  </div>
)

export default Field
